import { useEffect, useState, type ReactNode } from "react";
import { api } from "../lib/api";
import BlogsComingSoon from "./BlogsComingSoon";

export default function BlogAvailability({ children }: { children: ReactNode }) {
  const [availability, setAvailability] = useState<"loading" | "available" | "unavailable">("loading");
  useEffect(() => {
    let active = true;
    // [content.blog-availability](../../../docs/product/public-content.md#content-blog-availability): keep stories unmounted while checking; reserve Coming Soon for closed or failed checks.
    api.blogAvailability().then(status => {
      if (active) setAvailability(status?.blogAvailable === true ? "available" : "unavailable");
    }).catch(() => {
      if (active) setAvailability("unavailable");
    });
    return () => { active = false; };
  }, []);
  if (availability === "loading") return <div role="status" className="container-x py-24 text-center text-mut">Loading blogs…</div>;
  return availability === "available" ? children : <BlogsComingSoon />;
}
